export default __webpack_public_path__ + "static/media/2.704d39c3.jpg";